import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const SidebarActivityApi = createApi({
  reducerPath: "SidebarActivityApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["SIDEBARACTIVITY"],
  endpoints: (build) => ({
    getSidebarCount: build.query({
      query: ({ userId }) => ({
        url: `/sidebar/counts?userId=${userId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SIDEBARACTIVITY"],
    }),
    markAsViewed: build.mutation({
      query: (data) => ({
        url: `/sidebar/mark-viewed`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["SIDEBARACTIVITY"],
    }),
  }),
});

export const { useGetSidebarCountQuery, useMarkAsViewedMutation } =
  SidebarActivityApi;
